import {NgModule} from '@angular/core';
import {WheelOneComponent} from './wheel-one/wheel-one.component';


@NgModule({
  declarations: [WheelOneComponent],
  imports: [],
  exports: [WheelOneComponent]
})
export class LibraryWinwheelModule {
}
